module.exports = __webpack_public_path__ + "static/img/aisf_hover.34aa7799.gif";